import { render } from "./taxCityLife.vue?vue&type=template&id=39eded3c&scoped=true"
import script from "./taxCityLife.vue?vue&type=script&lang=js"
export * from "./taxCityLife.vue?vue&type=script&lang=js"

import "./taxCityLife.vue?vue&type=style&index=0&id=39eded3c&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39eded3c"]])

export default __exports__